import { useMemo } from "react";
import { CartItemTransformer } from "../services/objectTransformer/cart";

export const useFakeCartFromProduct = ({ productData, variantId, quantity }) => {
  return useMemo(() => {
    if (!productData?.product) return { cart: [], tax: null };

    const product = productData.product;
    const variant =
      product.variants.find(v => v.id === variantId) ||
      product.variants[0];

    if (!variant) return { cart: [], tax: null };

    const pricing = product.pricing;
    const displayGrossPrices = pricing?.displayGrossPrices;

    const price =
      displayGrossPrices
        ? pricing?.priceRange?.start?.gross?.amount
        : pricing?.priceRange?.start?.net?.amount;

    const currency = pricing?.priceRange?.start?.gross?.currency || "OMR";
    const tax = pricing?.priceRange?.start?.tax;

    const fakeLine = {
      id: "temp-line",
      quantity,
      variant: { ...variant, product },
      totalPrice: {
        gross: { amount: price * quantity, currency },
        net: { amount: (price - (tax?.amount || 0)) * quantity, currency },
        tax: { amount: (tax?.amount || 0) * quantity, currency },
      },
    };

    const transformed = CartItemTransformer(fakeLine);
    if (!transformed?.product) return { cart: [], tax: null };

    return { cart: [transformed], tax: fakeLine.totalPrice.tax };
  }, [productData, variantId, quantity]);
};
